module.exports = __webpack_public_path__ + "img/phone_logo.89d6de90.png";